/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function RadioStatisticsController($rootScope, $q, $document, $scope, $mdDialog, $timeout, $mdUtil, $translate,
                                               toast, types, gatewayCommandService, gatewayId) {

    var vm = this;

    vm.$onInit = function () {
        vm.gatewayId = gatewayId;
        vm.types = types;

        vm.pollingIntervalSec = 5;
        vm.doNotPoll = false;
        vm.radioStatisticsPollExecuting = false;
        vm.radioStatisticsPollTimeout = null;
        vm.rxErrorRate = null;

        vm.resetRadioStatisticsCounters = resetRadioStatisticsCounters;
        vm.pollingIntervalChanged = pollingIntervalChanged;
        vm.doNotPollChanged = doNotPollChanged;
        vm.pollNow = pollNow;
        vm.close = close;

        vm.loading = function () {
            return $rootScope.loading;
        };

        startRadioStatisticsPoll();
    };

    function close() {
        stopRadioStatisticsPoll();
        $mdDialog.cancel();
    }

    function startRadioStatisticsPoll() {
        vm.radioStatisticsPollExecuting = true;
        pollRadioStatistics(0);
    }

    function pollRadioStatistics(interval) {
        var intervalMs = angular.isDefined(interval) ? interval : vm.pollingIntervalSec * 1000;
        vm.radioStatisticsPollTimeout = $timeout(() => {
            gatewayCommandService.executeCommand(vm.gatewayId.id,
                types.radioStatisticsCommand.getRadioStatistics.value, {}, true).then(
                (data) => {
                    vm.radioStatistics = data;
                    vm.rxErrorRate = (vm.radioStatistics.numRxPackets ? (vm.radioStatistics.rxCrcErrPackets / vm.radioStatistics.numRxPackets) : 0).toFixed(6);
                    if (vm.radioStatisticsPollExecuting && !vm.doNotPoll) {
                        pollRadioStatistics();
                    }
                },
                (rejection) => {
                    onError(rejection.data);
                }
            );
        }, intervalMs);
    }

    function resetRadioStatisticsCounters() {
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.radioStatisticsCommand.resetRadioStatisticsCounters.value, {}).then(
            () => {
                vm.radioStatistics = null;
                vm.rxErrorRate = null;
            },
            (rejection) => {
                onError(rejection.data);
            }
        );
    }

    function pollingIntervalChanged() {
        stopRadioStatisticsPoll();
        if (!vm.doNotPoll) {
            startRadioStatisticsPoll();
        }
    }

    function doNotPollChanged() {
        if (vm.doNotPoll) {
            stopRadioStatisticsPoll();
        } else {
            startRadioStatisticsPoll();
        }
    }

    function pollNow() {
        stopRadioStatisticsPoll();
        startRadioStatisticsPoll();
    }

    function stopRadioStatisticsPoll() {
        vm.radioStatisticsPollExecuting = false;
        if (vm.radioStatisticsPollTimeout) {
            $timeout.cancel(vm.radioStatisticsPollTimeout);
            vm.radioStatisticsPollTimeout = null;
        }
    }

    function onError(error) {
        vm.radioStatisticsPollExecuting = false;
        var toastParent = angular.element('#tk-radio-statistics-dialog', $document);
        var dialogContent = toastParent.find('md-dialog-content');
        if (dialogContent.length > 0) {
            toastParent = dialogContent;
        }
        toast.showError(error, toastParent, 'bottom right');
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway/radio-statistics/radio-statistics.controller.js